import { takeLatest, put } from 'redux-saga/effects';
import { apiCall } from './network';
import {
  GET_AIRLINES,
  UPDATE_AIRLINE,
  ADD_NEW_AIRLINE,
  DELETE_AIRLINE
} from '../names';
import { AnyAction } from 'redux';
import {
  setAirlines,
} from 'reduxStore/actions/airlines';
import { toast } from 'react-toastify';
import * as R from 'ramda';
import { t } from 'I18n';

const URL = '/api/airlines';

function* getAirlines(action: AnyAction) {
  const headers = {
    'Content-Type': 'application/json'
  };
  const url = `${URL}${action.payload}`;

  try {
    const res = yield apiCall(url, 'GET', headers);
    const response = yield res.json();
    yield put(setAirlines(response));
  } catch (error) {
    console.error(error);
  }
}

function* updateAirline(action: AnyAction) {
  const headers = {
    'Content-Type': 'application/json'
  };
  const url = `${URL}/${action.payload.id}`;

  try {
    yield apiCall(url, 'PUT', headers, JSON.stringify(action.payload.data));
    action.payload.onSuccess();

    toast.success(t('int.airline-updated-successfully'));
  } catch (error) {
    const err = yield error.json();
    const errors = Object.keys(err.fieldErrors);
    errors.forEach(key => {
      toast.error(
        `${t(
          R.pathOr('int.an-error-has-occurred', ['fieldErrors', key], err)
        )} ${t(key)}`
      );
    });
  }
}

function* addNewAirline(action: AnyAction) {
  const headers = {
    'Content-Type': 'application/json'
  };
  const url = `${URL}`;

  try {
    yield apiCall(url, 'POST', headers, JSON.stringify(action.payload));
    action.payload.onSuccess();

    toast.success(t('int.airline-added-successfully'));
  } catch (error) {
    const err = yield error.json();
    const errors = Object.keys(err.fieldErrors);
    errors.forEach(key => {
      toast.error(
        `${t(
          R.pathOr('int.an-error-has-occurred', ['fieldErrors', key], err)
        )} ${t(key)}`
      );
    });
  }
}

function* deleteAirline(action: AnyAction) {
  const headers = {
    'Content-Type': 'application/json'
  };
  const url = `${URL}/${action.payload.id}`;

  try {
    yield apiCall(url, 'DELETE', headers);
    action.payload.onSuccess();

    toast.success(t('int.airline-deleted-successfully'));
  } catch (error) {
    const err = yield error.json();
    if (err?.error) {
      toast.error(t(err.error));
    }
  }
}
function* airlineWatcher() {
  yield takeLatest(GET_AIRLINES, getAirlines);
  yield takeLatest(UPDATE_AIRLINE, updateAirline);
  yield takeLatest(ADD_NEW_AIRLINE, addNewAirline);
  yield takeLatest(DELETE_AIRLINE, deleteAirline);
}

export default airlineWatcher;
